import { getCookie } from "../../common/utils"

export const checkHsCountryTags = (productTags) => {
    let returnObject = {
        noCountryOfOriginTag : null,
        noHsCodeTag : null,
    };
    productTags.forEach(tag => {
        if (tag === 'pfs:hidden:no-country-of-origin') {
            returnObject.noCountryOfOriginTag = true;
        } else if (tag === 'pfs:hidden:no-hs-code') {
            returnObject.noHsCodeTag = true;
        }
    });
    return returnObject
}

export const checkPromoEligibleTag = (productTags, promoTag) => {
    let returnValue = false;
    productTags.forEach(tag => {
        if (typeof tag === 'string') {
            if (tag === promoTag) {
                returnValue = true;
            }
        } else {
            if (tag.value === promoTag) {
                returnValue = true;
            }
        }
    });
    return returnValue;
}

export const sendGbViewProductEvent = (user_profile, product, nonUsd) => {
    const url = new URL(window.location.href);
    const groupByQuery = url.searchParams.get('groupBy');
    if (groupByQuery && product) {
        window.gbTracker.sendViewProductEvent({
            "product": {
                "productId": `${product.id}`,
                "title": product.title,
                "price": product.price,
                "collection": "ProductsProduction",
                "category": product.item_type,
                "sku": `${product.id}`,
            },
            "searchAttributionToken": getCookie('searchAttributionToken') || '',
            "experiments": [
                {
                    "experimentId": "RebagGroupByTest",
                    "experimentVariant": 'GroupBy',
                }
            ]
        });
        window.dataLayer.push({
            'event': 'api_provider',
            'type': 'view_product',
            'value': 'GroupBy',
            'non_USD': nonUsd,
        });
        setTimeout(() => {
            url.searchParams.delete('groupBy');
            // Create a new URL without the removed query parameters
            const newUrl = url.toString();

            // Replace the current URL with the new URL without reloading the page
            history.replaceState(null, '', newUrl);
        }, 1000)
    }
}
